module.exports = __webpack_public_path__ + "media/assets/images/rain_sometime_will_cloudy-4a23bd2ced59f0f8f513f8b94e14e799.png";